import { useEffect } from 'react';

const BASE = 'Ehimo Building & Civil Engineering';

export function useSEO(title, description) {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE}` : `${BASE} Ltd — Construction, Lagos`;
    setMeta('description', description);
    setOG('og:title', document.title);
    setOG('og:description', description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.href;
  }, [title, description]);
}

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (el) el.setAttribute('content', content);
}

function setOG(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
